/**
 * Бэкенд отдаёт денежные суммы в минимальных единицах (×100 к отображаемым сумам в сумах).
 */

export const API_AMOUNT_SCALE = 100;

/**
 * @param {unknown} raw
 * @returns {number | null}
 */
export function apiAmountToSom(raw) {
  if (raw == null || raw === "") {
    return null;
  }
  const n = Number(raw);
  if (Number.isNaN(n)) {
    return null;
  }
  return n / API_AMOUNT_SCALE;
}

/**
 * Формат суммы в сумах с двумя знаками после запятой (UI).
 * @param {unknown} somValue уже в сумах
 * @returns {string}
 */
export function formatSomNumber(somValue) {
  const x = Number(somValue);
  if (Number.isNaN(x)) {
    return "—";
  }
  const s = x.toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  /* ru-RU даёт «100 000,00»; для отображения как «100 000.00» — точка в дробной части */
  return s.replace(/,(\d{2})$/, ".$1");
}

/**
 * Маска ввода суммы: разряды целой части через пробел («10 000»), дробная часть до 2 знаков после точки.
 * @param {string} raw
 * @returns {string}
 */
export function formatSomAmountInputMask(raw) {
  const normalized = String(raw ?? "")
    .replace(/\s/g, "")
    .replace(",", ".");
  if (normalized === "") {
    return "";
  }

  let intPart = "";
  let fracPart = "";
  let dotSeen = false;
  for (let i = 0; i < normalized.length; i++) {
    const c = normalized[i];
    if (c >= "0" && c <= "9") {
      if (!dotSeen) intPart += c;
      else if (fracPart.length < 2) fracPart += c;
    } else if (c === "." && !dotSeen) {
      dotSeen = true;
    }
  }

  intPart = intPart.replace(/^0+(?=\d)/, "");

  /**
   * @param {string} digits
   */
  function spaceGroup(digits) {
    if (!digits) return "";
    const rev = digits.split("");
    const chunks = [];
    for (let k = rev.length; k > 0; k -= 3) {
      chunks.unshift(rev.slice(Math.max(0, k - 3), k).join(""));
    }
    return chunks.join(" ");
  }

  let out = spaceGroup(intPart);
  if (dotSeen) {
    out += fracPart.length > 0 ? `.${fracPart}` : ".";
  }
  return out;
}

/**
 * Значение из API (минимальные единицы ×100) → строка вида «100 000,00».
 * @param {unknown} raw
 * @returns {string}
 */
export function formatSomFromApi(raw) {
  const som = apiAmountToSom(raw);
  if (som == null) {
    return "—";
  }
  return formatSomNumber(som);
}

/** @deprecated используйте {@link formatSomFromApi} */
export function formatSomIntegerFromApi(raw) {
  return formatSomFromApi(raw);
}
